import React from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faStarExclamation } from '@fortawesome/pro-regular-svg-icons';

import { useDomainVerification } from '../../context';
import StepContent from './StepContent';

const fbOwnedDomains = 'https://business.facebook.com/settings/owned-domains';

const INSTRUCTIONS_HELPER_TEXT = 'To create "boosted posts" or "posts only" with our tool, you\'ll first need to verify your domain with Facebook';

// The below are wrapped in an array to allow for a mix of jsx and strings
// src: https://stackoverflow.com/questions/19266197/reactjs-convert-html-string-to-jsx
const INSTRUCTIONS_CHECKLIST = [
  [
    'Go to: ',
    <a href={fbOwnedDomains}>{fbOwnedDomains}</a>,
  ],
  'Select the Business Account you are using for your Facebook Ads',
  'Once on this page, click on the Add button and type your domain name in the text box',
];

export const Instructions = () => {
  const { next } = useDomainVerification();

  return (
    <StepContent
      title="Step 1"
      helperText={INSTRUCTIONS_HELPER_TEXT}
      checklist={INSTRUCTIONS_CHECKLIST}
    >
      <button type="button" className="verification-col-right-button" onClick={next}>Next</button>
      <div className="verification-col-right-protip">
        <Icon icon={faStarExclamation} className="star" />
        <span>Pro Tip: Keep this window open until you complete the process.</span>
      </div>
    </StepContent>
  );
};
